(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["omancare-modern"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = (root) => {
    const videos = [...root.querySelectorAll('[data-omx-video]:not([data-omx-initialized])')];
    if (!videos.length) return;
    videos.forEach((video) => { video.dataset.omxInitialized = 'true'; });
    if (matchMedia('(prefers-reduced-motion: reduce)').matches || navigator.connection?.saveData) return;
    if (!('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(({ target: video, isIntersecting }) => {
        if (!isIntersecting || document.hidden) {
          video.pause();
          return;
        }
        if (!video.dataset.omxLoaded) {
          video.dataset.omxLoaded = 'true';
          video.addEventListener('loadeddata', () => { video.classList.add('omx-video-ready'); }, { once: true });
          if (video.dataset.src) video.src = video.dataset.src;
          video.querySelectorAll('source[data-src]').forEach((source) => { source.src = source.dataset.src; });
          video.load();
        }
        video.play().catch(() => {});
      });
    }, { threshold: 0.1 });
    videos.forEach((video) => observer.observe(video));
    document.addEventListener('visibilitychange', () => {
      videos.forEach((video) => {
        if (document.hidden) video.pause();
        else { observer.unobserve(video); observer.observe(video); }
      });
    });
    document.addEventListener('shopify:section:unload', (event) => {
      if (videos.some((video) => event.target.contains(video))) observer.disconnect();
    });
  };
  const start = () => initialize(document);
  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start, { once: true });
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
